module.exports = __webpack_public_path__ + "media/icons/arrow-right-a7216cf6.png";